const IMG_RE = /^!\[([^\]]*)\]\((\S+?)\)$/;

export const stripImageLines = (text) => (text || "").split("\n").filter((l) => !IMG_RE.test(l.trim())).join("\n");

export default function RichBody({ text, className = "", paragraphClass = "text-imi-text/75 text-lg leading-[1.9] whitespace-pre-line", testId = "article-body" }) {
  const blocks = (text || "").split(/\n\s*\n/).filter((b) => b.trim());
  return (
    <div className={`space-y-7 ${className}`} data-testid={testId}>
      {blocks.map((b, i) => {
        const t = b.trim();
        const img = t.match(IMG_RE);
        if (img) return (
          <figure key={i} className="pt-2" data-testid="article-inline-image">
            <img src={img[2]} alt={img[1] || ""} loading="lazy" className="w-full h-auto border border-imi-border" />
            {img[1] && <figcaption className="mt-2 text-imi-text/45 text-xs uppercase tracking-[0.15em]">{img[1]}</figcaption>}
          </figure>
        );
        if (t.startsWith("## ")) return <h2 key={i} className="font-serif text-2xl md:text-3xl text-imi-text pt-4">{t.slice(3)}</h2>;
        if (t.startsWith("> ")) return <blockquote key={i} className="border-l-2 border-imi-gold pl-6 font-serif text-xl md:text-2xl text-imi-goldlight/90 italic">{t.slice(2)}</blockquote>;
        return <p key={i} className={paragraphClass}>{t}</p>;
      })}
    </div>
  );
}
